module.exports = __webpack_public_path__ + "static/img/场馆展示3.2d02aa82.png";